<div *ngIf="account; else noAccountTemplate" class="accountSignature d-flex align-items-center">
  <span
    class="accountSignature_avatar"
    [ngClass]="{
      'accountSignature_avatar--medium' : avatarSize === 'medium',
      'accountSignature_avatar--large' : avatarSize === 'large',
      'accountSignature_avatar--jumbo' : avatarSize === 'jumbo'
    }"
    [matTooltip]="account | accountDisplayName"
    [matTooltipDisabled]="!shouldDisplayTooltip"
  >
    {{account | accountDisplayName: true}}
  </span>
  <div class="d-flex flex-column ml-2" *ngIf="!useOnlyAvatar">
    <span>{{account | accountDisplayName}}</span>
    <span class="text-small accountSignature_email" *ngIf="shouldDisplayEmail">
      <ng-container>{{emailParts.localPart}}</ng-container>
      <wbr />
      <ng-container>{{emailParts.domainPart}}</ng-container>
    </span>
  </div>
</div>

<ng-template #noAccountTemplate>
  <mat-icon class="accountSignature_avatar" svgIcon="account-circle"></mat-icon>
</ng-template>
